/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestResponse from '../model/BadRequestResponse';
import ErrorResponse from '../model/ErrorResponse';
import FireControllerAssociation from '../model/FireControllerAssociation';
import InlineObject from '../model/InlineObject';
import Message from '../model/Message';

/**
* FireControllerAssociation service.
* @module api/FireControllerAssociationApi
* @version 1.1.0
*/
export default class FireControllerAssociationApi {

    /**
    * Constructs a new FireControllerAssociationApi. 
    * @alias module:api/FireControllerAssociationApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the fireControllerAssocationUserIdDelete operation.
     * @callback module:api/FireControllerAssociationApi~fireControllerAssocationUserIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Message} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a User ID and all of their associated Fire Controllers
     * @param {String} userId The User ID to delete with all of it's Fire Controller associations
     * @param {module:api/FireControllerAssociationApi~fireControllerAssocationUserIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Message}
     */
    fireControllerAssocationUserIdDelete(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling fireControllerAssocationUserIdDelete");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Message;
      return this.apiClient.callApi(
        '/fire-controller/association/{userId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerAssocationUserIdFireControllerDelete operation.
     * @callback module:api/FireControllerAssociationApi~fireControllerAssocationUserIdFireControllerDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerAssociation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete associated Fire Controller IDs of a User by ID
     * @param {String} userId The User ID to delete Fire Controller associations by ID
     * @param {String} fireControllerId The Fire Controller ID to dissociate
     * @param {module:api/FireControllerAssociationApi~fireControllerAssocationUserIdFireControllerDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerAssociation}
     */
    fireControllerAssocationUserIdFireControllerDelete(userId, fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling fireControllerAssocationUserIdFireControllerDelete");
      }
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling fireControllerAssocationUserIdFireControllerDelete");
      }

      let pathParams = {
        'userId': userId,
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = FireControllerAssociation;
      return this.apiClient.callApi(
        '/fire-controller/association/{userId}/{fireControllerId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerAssocationUserIdGetFireController operation.
     * @callback module:api/FireControllerAssociationApi~fireControllerAssocationUserIdGetFireControllerCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the Fire Controller IDs associated to the User ID
     * @param {String} userId The User ID to get the associated Fire Controller IDs of
     * @param {module:api/FireControllerAssociationApi~fireControllerAssocationUserIdGetFireControllerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
    fireControllerAssocationUserIdGetFireController(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling fireControllerAssocationUserIdGetFireController");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ['String'];
      return this.apiClient.callApi(
        '/fire-controller/association/{userId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the fireControllerUserAssociation operation.
     * @callback module:api/FireControllerAssociationApi~fireControllerUserAssociationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireControllerAssociation} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Associate a user to Fire Controllers
     * @param {module:model/FireControllerAssociation} fireControllerAssociation 
     * @param {module:api/FireControllerAssociationApi~fireControllerUserAssociationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireControllerAssociation}
     */
    fireControllerUserAssociation(fireControllerAssociation, callback) {
      let postBody = fireControllerAssociation;
      // verify the required parameter 'fireControllerAssociation' is set
      if (fireControllerAssociation === undefined || fireControllerAssociation === null) {
        throw new Error("Missing the required parameter 'fireControllerAssociation' when calling fireControllerUserAssociation");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/jason', 'application/json'];
      let returnType = FireControllerAssociation;
      return this.apiClient.callApi(
        '/fire-controller/association/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
